import { OrganizacionDTO } from 'src/app/clientes/utilidades/clientes.models';
import { Autorizacion } from 'src/app/nucleo/autorizacion/autorizacion.models';

/* Tareas del día */
export enum TareaDia {
  CREACION = 'creacion', // Creación de las órdenes
  MIPRES = 'mipres', // Verificación de moléculas Mipres
  PREPARACION = 'preparacion', // Preparación de las órdenes
  ETIQUETAS = 'etiquetas', // Impresión de las etiquetas
  RECOGIDA = 'recogida', // Recogida de las órdenes
  PLANILLA_RECOGIDA = 'planilla_recogida', // Impresión de la planilla de recogida
  ENRUTAMIENTO = 'enrutamiento', // Enrutamiento de los domicilios
  DESPACHO = 'despacho', // Despacho de los domicilios
  ENTREGA = 'entrega', // Entrega de los domicilios
  LEGALIZACION = 'legalizacion', // Legalización de los domicilios
}

/* Detalles de las tareas del día */
export type DetalleTareaDia = {
  slug: TareaDia;
  nombre: string;
  icono: string;
  descripcion: string;
  estadisticas: {
    slug: string;
    nombre: string;
    color?: string;
    ocultarPasado?: boolean;
  }[];
  botonPasado?: boolean;
};

/* Datos de las tareas del día */
export type DatosTareasDia = Record<TareaDia, Record<string, number>>;
